import React from 'react';

import Loader from '../components/UI/loader/Loader';

import { useGetUserQuery, useGetAuthTokenQuery } from '../services/ADapi';

const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const { isLoading } = useGetUserQuery();
  const { data: planFeatures = {}, isLoading: isTokenLoading } =
    useGetAuthTokenQuery();

  if (isLoading || isTokenLoading) {
    return <Loader />;
  }

  return (
    <AuthContext.Provider value={{ availableFeatures: planFeatures }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
